import { Tooltip } from '@/components/ui/tooltip';
import { chakra } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { isProfileUnlocked } from './creator-locks';
import { LockOpenIcon } from './LockOpenIcon';

/**
 * A small open padlock beside a creator's name when the free plan shows them
 * in full through one of its monthly profile unlocks; hovering or focusing it
 * says "Profile unlocked". No text, no coloured badge. Renders nothing for a
 * creator the brand works with or on a plan that masks nothing.
 */
export const UnlockedMarker = ({ creator }: { creator: unknown }) => {
  const { t } = useTranslation();
  if (!isProfileUnlocked(creator)) return null;
  const label = t('planLocks.unlock.done');

  return (
    <Tooltip content={label} showArrow>
      <chakra.span
        role="img"
        aria-label={label}
        tabIndex={0}
        display="inline-flex"
        alignItems="center"
        flexShrink={0}
        color="inkMuted"
        fontSize="13px"
        lineHeight="1"
        borderRadius="sm"
        _focusVisible={{ outline: '2px solid', outlineColor: 'primary.900', outlineOffset: '1px' }}
      >
        <LockOpenIcon aria-hidden />
      </chakra.span>
    </Tooltip>
  );
};
